import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'Euro',
})
export class EuroPipe implements PipeTransform {
  transform(value: number): string {
    if (value === undefined || value === null) {
      return '';
    }
    return '€\u00A0' + value.toLocaleString('nl-BE', { minimumFractionDigits: 2 });
  }
}
